import { StandardPageLayout } from "@/components/layouts/standard-page-layout";
import { ArticlesList } from "components/blog/articles-list";
import { Newspaper } from "lucide-react";
import { useHistory } from "react-router-dom";

export const WhatsNewPage = () => {
  const history = useHistory();

  const handleArticleClick = (identifier: string) => {
    history.push(`/whats-new/${identifier}`);
  };

  return (
    <StandardPageLayout
      pageTitle={{
        icon: Newspaper,
        title: "Whats New",
        description:
          "Stay up to date with the latest news, updates, and releases related to Geoscape. Explore recent articles and announcements to see what's new in the world of geospatial data.",
      }}
    >
      <ArticlesList onArticleClick={handleArticleClick} />
    </StandardPageLayout>
  );
};
